export default __webpack_public_path__ + "static/media/hopp-hopp-hopp.06fd0019.png";